import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { TableCellStyled } from './CopyTableCell.styled';
/**
 * Table cell that allows copying inner text to clipboard.
 *
 * Copies `children` or the specified in `copyValue` prop value.
 */
const CopyTableCell = forwardRef(({ copyValue, ...props }, ref) => {
    const handleClick = (event) => {
        if (props.children === undefined && copyValue === undefined)
            return;
        event.stopPropagation();
        copyToClipboard(props.children, copyValue)();
    };
    // @ts-expect-error idk
    return _jsx(TableCellStyled, { ref: ref, ...props, onClick: handleClick });
});
// TODO: (later) duplicate
function copyToClipboard(node, value) {
    return function () {
        if (value !== undefined) {
            navigator.clipboard.writeText(`${value}`);
            return;
        }
        if (!node || !(typeof node === 'string' || typeof node === 'number'))
            return;
        navigator.clipboard.writeText(`${node}`);
    };
}
export { CopyTableCell };
